<div class="mainheader" id="MenuHeader" [class.menus-suppressed]="desktopMenusSuppressed">
  <nav class="navbar menustyle" aria-label="Navegación principal">
    <button #mobileMenuToggle class="mobile-menu-toggle" type="button" aria-controls="navbarNav"
      [attr.aria-expanded]="isExpanded" [attr.aria-label]="isExpanded ? 'Cerrar navegación' : 'Abrir navegación'"
      (click)="toggleNavbar()">
      <mat-icon aria-hidden="true">menu</mat-icon>
    </button>

    <div class="drawer-backdrop" [class.is-visible]="isExpanded" (click)="closeMobileMenu()"
      [attr.aria-hidden]="!isExpanded"></div>

    <aside class="navbar-collapse" [class.show]="isExpanded" id="navbarNav" aria-label="Navegación">
      <div class="drawer-header">
        <div class="drawer-heading">
          <span class="drawer-eyebrow">SNIPERBOT</span>
          <h2>Navegación</h2>
        </div>
        <button class="drawer-close" type="button" aria-label="Cerrar navegación" (click)="closeMobileMenu()">
          <mat-icon aria-hidden="true">close</mat-icon>
        </button>
      </div>

      <div class="drawer-content">
        <ul class="navbar-nav multi-level">
          <li class="nav-entry">
            <a routerLink="/home" class="nav-link home-link" [class.active]="isRouteActive('/home')"
              matTooltip="Ir a inicio" (click)="closeMobileMenu()">
              <mat-icon aria-hidden="true">home</mat-icon>
              <span>Inicio</span>
            </a>
          </li>

          <li *ngFor="let element of navMenuList" class="nav-entry" [hidden]="element.hidden"
            [class.mobile-open]="isMenuExpanded(element)" [class.has-submenu]="hasVisibleSubmenu(element)"
            (mouseenter)="resumeDesktopMenus()" (focusin)="resumeDesktopMenus()">
            <a class="nav-link" [class.active]="isMenuActive(element)"
              [class.disable-a]="element.disabled" [routerLink]="hasVisibleSubmenu(element) ? null : element.link"
              [attr.aria-expanded]="hasVisibleSubmenu(element) ? isMenuExpanded(element) : null"
              [attr.aria-haspopup]="hasVisibleSubmenu(element) ? 'true' : null"
              [attr.tabindex]="hasVisibleSubmenu(element) ? 0 : null"
              [attr.role]="hasVisibleSubmenu(element) ? 'button' : null"
              [matTooltip]="element.tooltip" (click)="selectMenuItem($event, element)"
              (keydown.enter)="selectMenuItem($event, element)" (keydown.space)="selectMenuItem($event, element)">
              <mat-icon aria-hidden="true" [class.icon-dot]="getIcon(element) === 'fiber_manual_record'">{{ getIcon(element) }}</mat-icon>
              <span class="nav-label">{{ element.header || element.tooltip }}</span>
              <mat-icon *ngIf="hasVisibleSubmenu(element)" class="nav-chevron" aria-hidden="true">
                expand_more
              </mat-icon>
            </a>

            <ul *ngIf="hasVisibleSubmenu(element) || element.header?.toLowerCase() === 'sniper'" class="dropdown-menu">
              <li *ngFor="let subElement of filterMenuItems(element.submenu)" class="submenu-entry"
                [class.mobile-open]="isMenuExpanded(subElement)"
                [class.has-submenu]="hasVisibleSubmenu(subElement)">
                <a class="nav-menu-link" [class.active]="isMenuActive(subElement)"
                  [class.disable-a]="subElement.disabled"
                  [routerLink]="hasVisibleSubmenu(subElement) ? null : subElement.link"
                  [attr.aria-expanded]="hasVisibleSubmenu(subElement) ? isMenuExpanded(subElement) : null"
                  [attr.tabindex]="hasVisibleSubmenu(subElement) ? 0 : null"
                  [attr.role]="hasVisibleSubmenu(subElement) ? 'button' : null"
                  [matTooltip]="subElement.tooltip" (click)="selectMenuItem($event, subElement)"
                  (keydown.enter)="selectMenuItem($event, subElement)" (keydown.space)="selectMenuItem($event, subElement)">
                  <mat-icon aria-hidden="true" [class.icon-dot]="getIcon(subElement) === 'fiber_manual_record'">{{ getIcon(subElement) }}</mat-icon>
                  <span class="nav-label">{{ subElement.header }}</span>
                  <mat-icon *ngIf="hasVisibleSubmenu(subElement)" class="nav-chevron" aria-hidden="true">
                    expand_more
                  </mat-icon>
                </a>

                <ul *ngIf="hasVisibleSubmenu(subElement)" class="dropdown-submenu-level">
                  <li *ngFor="let subMenuElement of filterMenuItems(subElement.submenu)" class="submenu-entry">
                    <a class="nav-menu-link" [class.active]="isMenuActive(subMenuElement)"
                      [class.disable-a]="subMenuElement.disabled" [routerLink]="subMenuElement.link"
                      [matTooltip]="subMenuElement.tooltip" (click)="selectMenuItem($event, subMenuElement)">
                      <mat-icon aria-hidden="true" [class.icon-dot]="getIcon(subMenuElement) === 'fiber_manual_record'">{{ getIcon(subMenuElement) }}</mat-icon>
                      <span class="nav-label">{{ subMenuElement.header }}</span>
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <div class="drawer-user">
        <div class="user-avatar" aria-hidden="true">
          <mat-icon>person_outline</mat-icon>
        </div>
        <button class="about-button" type="button" aria-label="Acerca de" matTooltip="Info del sistema"
          (click)="openAboutDialog()">
          <mat-icon aria-hidden="true">info</mat-icon>
        </button>
        <button class="logout-button" type="button" aria-label="Cerrar sesión" matTooltip="Salir"
          (click)="cerrarSesion()">
          <mat-icon aria-hidden="true">logout</mat-icon>
        </button>
      </div>
    </aside>

  </nav>

  <ng-template #aboutDialog>
    <section class="about-dialog" role="document">
      <header class="about-dialog-header">
        <div class="about-dialog-logo-wrap">
          <img class="about-dialog-logo" src="assets/images/SBOT/SBOT_LOGO.png" alt="" aria-hidden="true">
        </div>
        <h2 id="about-dialog-title" mat-dialog-title>Acerca de SniperBot</h2>
      </header>

      <div mat-dialog-content class="about-dialog-content">
        <h3 class="about-section-title">Detalles técnicos</h3>
        <div class="about-technical-details">
          <div class="about-info-row">
            <span>Backend</span>
            <strong class="about-badge">.NET {{ backendVersion }}</strong>
          </div>
          <div class="about-info-row">
            <span>Frontend</span>
            <strong class="about-badge">Angular {{ angularVersion }}</strong>
          </div>
          <div class="about-info-row">
            <span>Fecha de compilación</span>
            <strong class="about-build-date">{{ buildDate | date:'dd/MM/yyyy HH:mm' }}</strong>
          </div>
        </div>

        <div class="about-credit">
          <span class="about-credit-label">Desarrollado por</span>
          <strong class="about-credit-brand">SniperBot<sup>®</sup></strong>
          <a class="about-website" href="https://www.sniperbot.com.ar" target="_blank" rel="noopener noreferrer">
            <span>www.sniperbot.com.ar</span>
            <mat-icon aria-hidden="true">open_in_new</mat-icon>
          </a>
        </div>
      </div>

      <div class="about-dialog-actions">
        <button type="button" class="about-close-button" cdkFocusInitial mat-dialog-close aria-label="Cerrar">
          Cerrar
        </button>
      </div>
    </section>
  </ng-template>
</div>
